module.exports = __webpack_public_path__ + "img/20.5df20f27.jpg";